import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineModelNumber";

const url = "/api/machines/MachineModelNumber";

export const machineModelNumberLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Model Number",
    url,
  }
);
